var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 30,
    height: 30,
    viewBox: "0 0 33.514 24.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.447,35.206V20.2a.49.49,0,0,0-.483-.5H323.578a.49.49,0,0,0-.483.5V43.5a.491.491,0,0,0,.483.5h32.385a.491.491,0,0,0,.483-.5V40.97s.009-.005.013-.009ZM324.752,43l10.356-10.285,2.245,2.318a3.379,3.379,0,0,0,4.835,0l1.992-2.058L354.71,43Zm-.69-21.69,10.364,10.7L324.061,42.3ZM355.48,42.378,344.864,32.271,355.48,21.31ZM341.5,34.331a2.432,2.432,0,0,1-3.467,0L324.829,20.693h29.884Z",
    transform: "translate(-323.02 -19.623)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.491d5df6a13ff23aede6f95e16ccd079.svg";
export { ForwardRef as ReactComponent };